import { userTypes } from '../constants/userTypes';
import * as dsaTypes from '../constants/dsaTypes';

export const isPartnerUser = (user) => {
  return user.type === userTypes.PARTNER_USER || user.type === userTypes.PARTNER_ADMIN;
};

export const isInternalUser = (user) => {
  return user.type === userTypes.INTERNAL;
};

export const getAssessmentTitle = (type) => {
  return {
    [dsaTypes.NEW_CUSTOMER_DSA]: 'New Customer DSA',
    [dsaTypes.FULL_DSA]: 'DSA'
  }[type];
};


// WEBPACK FOOTER //
// ./src/utils/assessmentUtils.js